export const enum Key {
  Escape = 'Escape',
}
